export enum KitModelTypes {
  DoorSensor = 96
}

export enum NoticeModes{
  LowVoltage = 14,  
  SAS = 21,
  SAW = 22,
  SAF = 23,
}
export enum AccountTenantTypeEnum{
  MultiTenant = 1,
  SingleFamily = 2
}
export enum AccessTypesEnum {
  ReadOnly = 1,
  Admin = 2
}
export enum AccessCodeTypesEnum {
  GateCode = 1,
  RFIDTag = 2,
  AccessCard = 3,
  ClickerRemote = 4,
  PhoneNumber = 5,
  RFIDCardClicker = 6,
  CellgateEncryptedCredential = 7,
  BluetoothAccess = 8,
  QR =9,
  ProxCard = 11,
  CGKeypad = 12
}
export enum BLECodeTypesEnum {
  FacilityCode = 1,
  Range = 2,
  Both = 3
}
export enum EntryTypesEnum {
  Alarm_O = 1,
  Camera = 2,
  Door = 3,
  Gate = 4,
  Lock = 5,
  Sensor = 6,
  Trap = 8,
  KeyPad = 9,
  CardReader = 10,
  RFID = 11,
  RFRemoteReceiver = 12,
  PostalLock = 286,
  Alarm_I = 287,
  MassOpenClose = 288,
  CGProxReaderBT = 289,
  CGProxKeypadBT = 290,
  CGEncryptedReaderBT = 291,
  CGEncryptedKeypadBT = 292,
  CRReader = 293,
  CRKeypad = 294,
  CRInfinity = 295,
  Bluetooth = 296,
  QRCode = 297,
  Encrypted = 298,
}

/** Entry types eligible for Add Code on account/activity logs */
export const ADD_CODE_ENTRY_TYPE_IDS: readonly number[] = [
  EntryTypesEnum.CardReader,
  EntryTypesEnum.RFID,
  EntryTypesEnum.RFRemoteReceiver,
  EntryTypesEnum.CGProxReaderBT,
  EntryTypesEnum.CGProxKeypadBT,
  EntryTypesEnum.CGEncryptedReaderBT,
  EntryTypesEnum.CGEncryptedKeypadBT,
  EntryTypesEnum.CRReader,
  EntryTypesEnum.CRKeypad,
  EntryTypesEnum.CRInfinity,
  EntryTypesEnum.Bluetooth,
  EntryTypesEnum.Encrypted,
];

export function isAddCodeEntryType(entryTypeId: number): boolean {
  return (ADD_CODE_ENTRY_TYPE_IDS as readonly number[]).includes(entryTypeId);
}

/** Gate/access code: DecodedAccessCode present, and either no WiegandCode or KeyPad entry. QR Code Readers never qualify. */
export function canShowKeyPadAddCode(row: {
  WiegandCode?: unknown;
  DecodedAccessCode?: unknown;
  IsQRCode?: boolean;
  ModulePort?: { EntryTypeID?: number };
}): boolean {
  if (!row?.DecodedAccessCode) {
    return false;
  }
  if (row.IsQRCode || row.ModulePort?.EntryTypeID === EntryTypesEnum.QRCode) {
    return false;
  }
  if (!row.WiegandCode) {
    return true;
  }
  return row.ModulePort?.EntryTypeID === EntryTypesEnum.KeyPad;
}

export enum EntryTypeEnums {
  Camera = "Camera",
  CR_Infinity = "CR-Infinity",
 CR_Keypad = "CR-Keypad",
 CR_Reader = "CR-Reader"
}
export enum PortalTypeEnums{
   User_Portal=3 
}
export enum ActionTypes{
  Add = 1,
  Update = 2
}
export const KitHardwareType = {
  Entria: {
    ID: 84,
    Name: "Entria 4DC",
  },
  U3: {
    ID: 83,
    Model: "Entria SDC",
  },
  Elevator: {
    ID: 85,
    Model: "Elevator",
  },
  W480: {
    ID: 16,
    Model: "W480",
  },
} as const;

export enum NoticeEnums{
  Code='SAW'
  }
export const NoticeTypeEnums =
  {
   SAW :{
    ID : 22,
    Code :'SAW'
   }
  } as const;
  
export enum PortTypesEnums
{
  OutputPortType="O",
  PortNumber1W = "1W",
  ModulePortID = 0
}

export enum RouteURL
{
  SingleFamilyManualSetup = '/site/single-family-manual-setup',
  MyWebAccount = '/site/mywebaccount',
  MyWebAccountEdit = '/site/mywebaccount/edit'
}

export enum BillingType  {
  Invoice= 1,
  credit_card = 2,
  bank_account = 3
}

export enum BillingLogType {
  Charge = 1
}
enum KitHardwareTypes {
  GT48 = "GT48",
  WIM = "WIM",
  CCM = "CCM",
  CTE = "CTE",
  WTMEVO = "WTM-EVO",
  IPCAM = "IP-CAM",
  U2 = "U2",
  TalkMan = "TalkMan",
  WXL = "WXL",
  W480 = "W480",
  W461 = "W461",
  OmniPointGateway = "OMNI-POINT Gateway",
  OmniPointEPMV1 = "OMNI-POINT EPM V1",
  SensorLora = "Sensor-Lora",
  OmniPointEPMV2 = "OMNI-POINT EPM V2",
  EntriaSDC = "Entria SDC",
  Entria4DC = "Entria 4DC",
  W410 = "W410",
  W450 = "W450"
}
export const ModuleKitHardwareType = Object.values(KitHardwareTypes);


export enum ActuationModeTypes {
  MomentaryOpen = 1,
  HoldOpen = 2,
  Both = 3
}

export enum PaymentVerificationType 
{instant=1, 
  micro_deposit
}

export enum InvoiceStatusType
{
  Open = 3,
  Paid = 5,
  Processing = 9,
}
export enum CallgroupTierTypeEnum{
  Standard=1,
  SingleTier=2
}

export enum CallgroupTypeEnum{
  VideoCallGroup=1,
  VoiceCallGroup=2
}

export enum UserGroupCategoriesEnum {
  AdminMT = 1
}

export enum UserGroupProfilesEnum {
  DivisionManagerProfile = 'DivisionManagerProfile'
}

export enum UserGroupProfileDescriptionsEnum {
  AccountAdmin = 'Account Admin'
}
export const EntryTypes = {
  Alarm: {
    ID: 1,
    Name: "Alarm",
  },
  Camera: {
    ID: 2,
    Name: "Camera",
  },
  Door: {
    ID: 3,
    Name: "Door",
  },
  Gate: {
    ID: 4,
    Name: "Gate",
  },
  Lock: {
    ID: 5,
    Name: "Lock",
  },
  Sensor: {
    ID: 6,
    Name: "Sensor",
  },
  Switch: {
    ID: 7,
    Name: "Switch",
  },
  Trap: {
    ID: 8,
    Name: "Trap",
  },
  KeyPad: {
    ID: 9,
    Name: "Key Pad",
  },
  CardReader: {
    ID: 10,
    Name: "Card Reader",
  },
  RFID: {
    ID: 11,
    Name: "RFID",
  },
  RFRemoteReceiver: {
    ID: 12,
    Name: "RF Remote Receiver",
  },
  PostalLock: {
    ID: 286,
    Name: "Postal Lock",
  },
  AlarmSecondary: {
    ID: 287,
    Name: "Alarm Input",
  },
  MassOpenClose: {
    ID: 288,
    Name: "Mass Open/Close",
  },
  CGProxReaderBT: {
    ID: 289,
    Name: "CG Prox Reader + BT",
  },
  CGProxKeypadBT: {
    ID: 290,
    Name: "CG Prox Keypad + BT",
  },
  CGEncryptedReaderBT: {
    ID: 291,
    Name: "CG Encrypted Reader + BT",
  },
  CGEncryptedKeypadBT: {
    ID: 292,
    Name: "CG Encrypted Keypad + BT",
  },
  CRReader: {
    ID: 293,
    Name: "CR-Reader",
  },
  CRKeypad: {
    ID: 294,
    Name: "CR-Keypad",
  },
  CRInfinity: {
    ID: 295,
    Name: "CR-Infinity",
  },
  Bluetooth: {
    ID: 296,
    Name: "Bluetooth",
  },
  QRCode: {
    ID: 297,
    Name: "QRCode",
  },
  Encrypted: {
    ID: 298,
    Name: "Encrypted",
  },
} as const;

export const PortTypes = {
  Input: {
    ID: 1,
    Name: "Input",
  },
  Output: {
    ID: 2,
    Name: "Output",
  },
  Wiegand: {
    ID: 3,
    Name: "Wiegand",
  },
} as const;

export enum ContactMessageEnum {
  BillingContactDelete = 'This billing contact is currently mapped as the account\'s primary billing contact and cannot be deleted. Please assign another billing contact before deleting this contact.'
}